import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LanguageStringAutoCompleteComponent } from './language-string-auto-complete.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
  ],
  declarations: [LanguageStringAutoCompleteComponent],
  exports: [LanguageStringAutoCompleteComponent],
})
export class LanguageStringAutoCompleteModule {
}
